import envConfigs from "./envConfigs"

export const MULTILANGUAGE_SUPPORT_ENABLED = envConfigs.MULTILANGUAGE_SUPPORT_ENABLED
export const UNKNOWN_SHIPPER_ENABLED = envConfigs.UNKNOWN_SHIPPER_ENABLED
export const MASS_BOOKING_ENABLED = envConfigs.MASS_BOOKING_ENABLED
export const ENABLE_ANALYTICS = envConfigs.ENABLE_ANALYTICS
export const DASHBOARD_ALLOTMENT_VIEW_ENABLED = envConfigs.DASHBOARD_ALLOTMENT_VIEW_ENABLED